import LocalStorage, { StorageKeys } from 'utils/local-storage';
import { loggerBaseFields } from 'utils/logger';

// this is set here to avoid a circular reference that causes build issues
if (loggerBaseFields) {
  loggerBaseFields.userId = LocalStorage?.getItem(StorageKeys.USER_AUTH_TOKEN) ?? undefined;
}

export default LocalStorage;
